import React from "react";
import PropTypes from 'prop-types';

import {
    MaterialRating
} from './styled'

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';

import { ThemedComponent } from "ui/theme";


export const Slider = ({ value, onChange, label, secondary, compact, disabled, max }) => {

    return (
        <>
            <ThemedComponent>
                <FormGroup>
                    {label ? <FormLabel component="legend" color={secondary ? 'secondary' : 'primary'} >{label}</FormLabel> : null}
                    <MaterialRating
                        aria-label={label || 'Rating'}
                        compact={compact}
                        disabled={disabled}
                        max={max}
                        value={value}
                        onChange={(event, newValue) => {
                            onChange(newValue);
                        }} color={secondary ? 'secondary' : 'primary'} />
                </FormGroup>
            </ThemedComponent>

        </>
    );
}

Slider.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.number,
    secondary: PropTypes.bool,
    compact: PropTypes.bool,
    disabled: PropTypes.bool,
    max: PropTypes.number,
    onChange: PropTypes.func.isRequired,
};


Slider.defaultProps = {
    label: '',
    value: 0,
    secondary: false,
    compact: false,
    disabled: false,
    max: 5,
    onChange: undefined,
};

export default Slider;
